








import Vue from 'vue';
import {Component} from "vue-property-decorator";
import History from "./Game/History.vue";
import CodeList from "./Code/CodeList.vue";

@Component({
    components: {History, CodeList},
    props: {}
})

export default class Profile extends Vue {

    mounted(): void
    {
    }
}
